module.exports = "/images/login-box-bg.png?5d7379854a2ff52993ed1268a4f9e85a";